import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-tryher-grid-percent.js';

const percentCard = ({ image, content, percent }) => `
  <div data-attribute="tryher-grid-percent__item" class="swiper-slide">
    <article class="tryher-grid-percent__card">
      <div class="tryher-grid-percent__media">
        <img
          loading="lazy"
          data-attribute="tryher-grid-percent__image"
          class="tryher-grid-percent__image"
          src="${image}"
          alt="Customer visible result"
        />
        <div data-attribute="tryher-grid-percent__percent" data-value="${percent}" class="tryher-grid-percent__percent">
          <svg viewBox="0 0 64 64" aria-hidden="true">
            <circle class="tryher-grid-percent__percent-track" cx="32" cy="32" r="28" pathLength="100"></circle>
            <circle class="tryher-grid-percent__percent-value" cx="32" cy="32" r="28" pathLength="100" stroke-dasharray="${percent} 100"></circle>
          </svg>
          <strong data-attribute="tryher-grid-percent__percent-text">${percent}%</strong>
        </div>
      </div>
      <div data-attribute="tryher-grid-percent__content" class="tryher-grid-percent__content">${content}</div>
    </article>
  </div>`;

const items = [
  {
    image: 'https://cdn.skyfastimg.com/images/2026/07/22/image-6a608852481fbd35524bd5aa.webp?w=1000',
    percent: 97,
    content: '<p>Said Under-Eyes Looked Less Hollow</p>',
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/07/22/image-6a608868af07d9079f10af7b.webp?w=1000',
    percent: 94,
    content: '<p>Noticed Lines Look Softer + Skin Looked Smoother</p>',
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/07/22/image-6a60887eaa36974d0bb94d7e.webp?w=1000',
    percent: 92,
    content: '<p>Said Their Skin Looked More Fresh + Rested</p>',
  },
];

const contentHtml = `
  <div
    data-attribute="tryher-grid-percent"
    class="tryher-grid-percent container"
    data-card-background-color="#FFFFFF"
    data-card-text-color="#000000"
    data-percent-line-color="#FF6099"
    data-percent-text-color="#FFFFFF"
    data-container-full-width="false"
    data-breakpoint-mobile-slides="1.5"
    data-breakpoint-tablet-slides="3"
    data-breakpoint-desktop-slides="3"
    style="--card-background-color: #ffffff; --card-text-color: #000000; --percent-line-color: #ff6099; --percent-text-color: #ffffff"
  >
    <div data-attribute="tryher-grid-percent__header" class="tryher-grid-percent__header">
      <h2 style="text-align: center"><strong>Visible Changes You Can Actually See</strong></h2>
    </div>
    <div class="swiper tryher-grid-percent-swiper-unique-id">
      <div data-attribute="tryher-grid-percent__list" class="swiper-wrapper">
        ${items.map(percentCard).join('')}
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#FFF7FC',
});
